import $ from 'jquery';

import { View } from 'backbone';
import listService from 'ListService.js';
import _template from 'workflow/properties/main/custom-behavior.ejs';


class CustomBehaviorView extends View {

    initialize( opts ) {
        this.options = opts || {};
        this.template = _template;
        this.tagName = 'div';
        this.id = opts.el;   
        this.events = {  
                  'click #editBehavior'   : 'edit',  
                  'click #removeBehavior' : 'remove'  
             };  
                 

        if (!this.model.get('behaviorCommands')) {
            this.model.set('behaviorCommands', 'undefined', {silent: true});
        }
        // count behavior objects for display
        this.updateBehaviorCount();

        //this.listenTo(this.model, 'change', this.render);       
        return this;
    }


    updateBehaviorCount() {
        let count = 0;
        const inst = listService.getBehaviorInstanceByObject(this.model.get('id')).first();
        if (inst) {
            const commands = listService.getBehaviorInstanceObjects(inst.get('id'), null);
            count = commands.size;
        }
        if (count > 0) {
            this.model.set('behaviorCommands',count + ' commands', {silent:true});
        } else {
            this.model.set('behaviorCommands', 'undefined', {silent: true});
        }
    }

    edit() {
        // PF-1951 Turning on flag for back-button purposes
        listService.linkClicked = true;
        if (this.model.get('id').includes('/')){
            listService.useBehaviorId = true;
            listService.behaviorId = this.model.get('id');
            let idForLoading = listService.cleanId(this.model.get('id'));
            Backbone.history.loadUrl('behaviors/' + idForLoading + '/workflow');
        } else {
            Backbone.history.loadUrl('behaviors/' + this.model.get('id') + '/workflow');
        }
        const inst = listService.getBehaviorInstanceByObject(this.model.get('id')).first();
        inst.attributes.owner = this.model.get('name');
        inst.attributes.text = this.model.get('name');
    }

    remove() {
        this.model.set('behaviorCommands', 'undefined', {silent: true});

        const inst = listService.getBehaviorInstanceByObject(this.model.get('id'));
        inst.map( (instance, id) => {
            listService.destroyBehaviorInstance(id);
        });
        this.model.set('behaviorCommands', 'undefined', {silent: true});
        $('#behaviorCommands').val('undefined');
        this.model.set('hasScripts', false);
        this.model.set('hasNotifications', false);
    }

    render() {
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        $('#behaviors-section .switch').click(function () {
            $(this).find('i').toggleClass('pf-carot-down pf-carot-left');
        });
      
        this.delegateEvents();
        return this;
    }

}

export default CustomBehaviorView;
